<template>
  <div class="file-requirement-new">
    <Row :gutter="16">
      <i-col span="12">
        <Form ref="newForm" :model="fileReqModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="fileReqModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="描述" prop="description">
            <Input v-model="fileReqModel.description" type="textarea" :rows="4" placeholder="输入描述" />
          </FormItem>
          <FormItem label="必填">
            <i-switch v-model="fileReqModel.isRequired" size="large">
              <span slot="open">是</span>
              <span slot="close">否</span>
            </i-switch>
          </FormItem>
          <FormItem label="文件格式" prop="formats">
            <Select v-model="fileReqModel.formatSelected" clearable multiple @on-change="changeFormats">
              <Option v-for="item in formats" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem label="大小限制kb" prop="maxLength">
            <InputNumber :min="0" style="width: 200px"
              v-model="fileReqModel.maxLength" :step="1000" placeholder="输入大小限制(kb)"></InputNumber>
            <span class="small font-grey" style="margin-left:5px">0为不限</span>
          </FormItem>
          <FormItem label="城市" prop="cityId">
            <Cascader :data="cities" :load-data="loadCityData" @on-change="citySelected" placeholder="选择城市"></Cascader>
          </FormItem>
          <FormItem label="行业领域" prop="industryId">
            <Select v-model="fileReqModel.industryId" filterable placeholder="选择专属行业/领域">
              <Option :value="null">不限</Option>
              <Option v-for="item in industries" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
          </FormItem>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'file-requirement-new',
  props: {
    tid: Number
  },
  data () {
    return {
      loading: false,
      fileReqModel: {
        id: null,
        name: null,
        maxLength: null,
        formatSelected: null,
        formats: null,
        description: null,
        cityId: null,
        industryId: null,
        guarantorId: null,
        isRequired: true
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        maxLength: [
          { required: true, type: 'number', message: '请填写', trigger: 'blur' }
        ],
        formats: [
          { required: true, message: '请选择', trigger: 'blur' }
        ]
      },
      cities: [],
      industries: [],
      formats: [
        {
          label: '图片(jpg,jpeg,gif,png,bmp,pdf)',
          value: 'jpg,jpeg,gif,png,bmp,pdf'
        },
        {
          label: '文档(doc,docx,txt,pdf)',
          value: 'doc,docx,pdf'
        },
        {
          label: '电子表格(xls,xlsx)',
          value: 'xls,xlsx'
        }
      ]
    }
  },
  watch: {
    'tid': function (newVal) {
      if (newVal) {
        this.fileReqModel.id = newVal
      }
    }
  },
  mounted () {
    if (this.tid) {
      this.fileReqModel.id = this.tid
    }
    this.fileReqModel.guarantorId = parseInt(this.$route.params.guarantorId)
    this.initCitySelect()
    this.initIndustrySelect()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    changeFormats (e) {
      let result = []
      e.forEach(s => {
        let f = s.split(',')
        f.forEach(item => {
          if (result.findIndex(o => o === item) === -1) {
            result.push(item)
          }
        })
      })
      this.fileReqModel.formats = result.join(',')
    },
    initCitySelect () {
      Api.City.listCities({
        tier: 1,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          return {
            id: c.tid,
            value: c.tid,
            label: c.name,
            tier: c.tier,
            parent: c.parent,
            loading: false,
            children: []
          }
        })
        this.cities = data
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
      })
    },
    loadCityData (item, callback) {
      item.loading = true
      let parentId = item.value
      let tier = item.tier || 0
      let curNode = null
      if (tier === 1) {
        curNode = this.cities.filter((c) => {
          return c.id === item.id
        })[0]
      } else {
        let parentNode = this.cities.filter((c) => {
          return c.id === item.parent
        })
        curNode = parentNode[0]
      }
      console.log(curNode)
      Api.City.listCities({
        tier: tier + 1,
        parentId: parentId,
        isVisible: null
      }, 1, 1000).then((cities) => {
        let data = cities.data.map((c) => {
          if (tier === 1) {
            return {
              id: c.tid,
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent,
              loading: false,
              children: []
            }
          } else {
            return {
              value: c.tid,
              label: c.name,
              tier: c.tier,
              parent: c.parent
            }
          }
        })
        let retData = [{
          value: parentId,
          label: '本级'
        }]
        data.forEach((d) => {
          retData.push(d)
        })
        if (tier === 0) {
          curNode = retData
        } else {
          item.children = retData
        }
        item.loading = false
        callback()
      }).catch(err => {
        this.$Message.error('获取城市列表失败!' + err.message)
        item.loading = false
        callback()
      })
    },
    citySelected (val) {
      if (val instanceof Array) {
        this.industryModel.cityId = val[val.length - 1]
      } else {
        this.industryModel.cityId = val
      }
    },
    initIndustrySelect () {
      this.$Api.Industry.listIndustries({
      }, 1, 1000).then((res) => {
        let data = res.data.map((c) => {
          return {
            id: c.id,
            value: c.id,
            label: c.name
          }
        })
        this.industries = data
      }).catch(err => {
        this.$Message.error('获取行业列表失败!' + err.message)
      })
    },
    async submit () {
      this.$refs.newForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          if (this.tid) {
            await Api.Guarantee.updateFileRequirement(this.fileReqModel)
              .then((payload) => {
                console.log('suc', payload)
                this.$Message.success('修改成功!')
                this.loading = false
                this.$Spin.hide()
              })
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
          } else {
              await Api.Guarantee.createFileRequirement(this.fileReqModel)
              .then((payload) => {
                console.log('suc', payload)
                this.$Message.success('新增成功!')
                this.fileReqModel= {
                  name: null,
                  maxLength: null,
                  formatSelected: null,
                  formats: null,
                  description: null,
                  cityId: null,
                  industryId: null,
                  guarantorId: parseInt(this.$route.params.guarantorId),
                  isRequired: true
                }
                this.loading = false
                this.$Spin.hide()
              })
              .catch(err => {
                console.log('err', err)
                this.$Message.error('提交失败!' + err.message)
                this.loading = false
                this.$Spin.hide()
              })
          }
        }
      })
    }
  }
}
</script>

<style lang="less">
</style>
